/**
 * Singleton tracker for in-flight API requests.
 *
 * Used by axios interceptors (lib/api.js) to bump a counter on every
 * request start and decrement on settle. A React component subscribes
 * to changes so a global top-of-page progress bar can animate based
 * on whether anything is in flight.
 *
 * Designed as a tiny pub/sub so we don't pull in Zustand/Redux just for
 * this. Subscribe returns an unsubscribe function (typical React
 * effect-cleanup pattern).
 */
let inFlight = 0;
const listeners = new Set();

function notify() {
  for (const fn of listeners) {
    try { fn(inFlight); } catch (_) { /* listener errors must not break interceptor flow */ }
  }
}

export function start() {
  inFlight += 1;
  notify();
}

export function done() {
  inFlight = Math.max(0, inFlight - 1);
  notify();
}

export function getInFlight() {
  return inFlight;
}

export function subscribe(fn) {
  listeners.add(fn);
  // Fire immediately so subscribers know the current state.
  try { fn(inFlight); } catch (_) { /* ignore */ }
  return () => listeners.delete(fn);
}
